import styled from '@emotion/styled';
import {
  Button,
  DialogActions,
  DialogContent as _DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from '@material-ui/core';
import { List } from 'immutable';
import { ClassAttributes, createElement, FC, MouseEvent, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import FacebookAdAccount from '../../../entity/FacebookAdAccount';
import { SPACING_REGULAR } from '../../constant/spacing';
import Dialog from '../primitive/DialogWithPadding';
import FacebookAdAccountList from './FacebookAdAccountList';

type Props = ClassAttributes<HTMLElement> & {
  facebookAdAccounts: List<FacebookAdAccount>;
  open: boolean;
  onRequestSendingCreative: (e: MouseEvent<HTMLElement>, facebookAdAccount: FacebookAdAccount) => void;
  onRequestClose: () => void;
  className?: string;
};

const IntegrateFacebookAdAccountDialog: FC<Props> = ({
  facebookAdAccounts,
  open,
  onRequestSendingCreative,
  onRequestClose,
  className,
}) => {
  const [selectedAdAccount, setSelectedAdAccount] = useState<FacebookAdAccount | null>(null);
  const onClickAdAccount = (_: any, selected: FacebookAdAccount) => setSelectedAdAccount(selected);
  const onClickSendButton = async (e: any) => {
    if (selectedAdAccount !== null) {
      await onRequestSendingCreative(e, selectedAdAccount);
    }
    onRequestClose();
  };

  return (
    <Dialog open={open} onRequestClose={onRequestClose} className={className} maxWidth="md">
      <DialogTitle disableTypography>
        <Typography variant="h6">
          <FormattedMessage id="integrate_facebook_ad_account_dialog.title" />
        </Typography>
        <Description>
          <FormattedMessage id="integrate_facebook_ad_account_dialog.description" />
        </Description>
      </DialogTitle>

      <ContentLayout>
        <DialogContent>
          <FacebookAdAccountList
            facebookAdAccounts={facebookAdAccounts}
            selected={selectedAdAccount}
            onClick={onClickAdAccount}
          />
        </DialogContent>
      </ContentLayout>

      <DialogActions>
        <Button disabled={!selectedAdAccount} onClick={onClickSendButton}>
          <FormattedMessage id="integrate_facebook_ad_account_dialog.send" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const Description = styled(DialogContentText)({
  marginTop: SPACING_REGULAR,
});

const ContentLayout = styled('div')({
  display: 'flex',
  justifyContent: 'center',
});

const DialogContent = styled(_DialogContent)({
  paddingTop: '0 !important',
  paddingBottom: 0,
  maxWidth: 750,
});

export default IntegrateFacebookAdAccountDialog;
